import SimpleReportFilterDataTable from "./SimpleReportFilterDataTable";

export default SimpleReportFilterDataTable;
